// src/pages/NotFound.jsx
import Layout from "../layouts/Layout";
import Breadcrumb from "../components/Breadcrumb";
import { Link } from "react-router-dom";
const NotFound = () => (
  <Layout>
    <Breadcrumb
      title="Error 404"
      parent={{ name: "Trang chủ", path: "/" }}
    />

    <section className="error-section section-padding fix">
      <div className="container">
        <div className="error-content text-center">
          <h2
            className="wow fadeInUp"
            data-wow-delay=".3s"
          >
            4<span>0</span>4
          </h2>
          <h3
            className="wow fadeInUp"
            data-wow-delay=".5s"
          >
            Trang bạn tìm không tồn tại
          </h3>
          <p
            className="wow fadeInUp"
            data-wow-delay=".6s"
          >
            Xin lỗi, chúng tôi không tìm thấy trang bạn đang tìm kiếm. Hãy quay
            về trang chủ.
          </p>
          <Link
            to="/"
            className="theme-btn style-line-height mt-5 wow fadeInUp"
            data-wow-delay=".7s"
          >
            Quay về trang chủ
          </Link>
        </div>
      </div>
    </section>
  </Layout>
);

export default NotFound;
